import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaSignOutAlt, FaUserCircle } from "react-icons/fa";
import NotificationBell from "../Components/NotificationBell";
import { offCanvaChange, sideBarChange } from "../Reducer/componentSlice";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { useSocketPresence } from "../Contexts/SocketPresenceProvider";
import { textCapitalize } from "../Helpers/Utils";
import Logo from "../Assets/images/logo.svg";

const Header = () => {
    const { logOut, profile, siteDetails } = useAuth();
    const { connectionStatus } = useSocketPresence() || {};
    const dispatch = useDispatch();
    const component = useSelector((state) => state.component);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (width < 992) {
            if (component.offCanva === false) dispatch(sideBarChange(true));
            dispatch(offCanvaChange(true));
        } else {
            dispatch(offCanvaChange(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [width]);

    const openMobileNav = () => {
        dispatch(sideBarChange(!component?.sideBar));
        dispatch(offCanvaChange(true));
    };

    const adminName = textCapitalize(profile?.name || profile?.adminId || "Admin");

    return (
        <header className="app-header">
            <div className="app-header-inner">
                <div className="d-flex align-items-center gap-2">
                    <button
                        type="button"
                        className="btn btn-sm topnav-hamburger d-lg-none"
                        onClick={openMobileNav}
                        aria-label="Toggle navigation menu"
                    >
                        <span className={`hamburger-icon ${component?.sideBar ? "" : "open"}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </button>
                    <Link to="/dashboard" className="app-header-brand">
                        <img src={siteDetails?.logo || Logo} alt={siteDetails?.siteName || "logo"} className="header-logo" />
                    </Link>
                </div>

                <div className="d-flex align-items-center gap-2">
                    <NotificationBell />
                    <div className="dropdown">
                        <button type="button" className="btn app-user-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <span className="app-avatar">
                                <FaUserCircle />
                                <span
                                    className={`presence-dot presence-${connectionStatus || "offline"}`}
                                    title={`You are ${connectionStatus || "offline"}`}
                                />
                            </span>
                            <span className="app-user-name d-none d-sm-inline">{adminName}</span>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end dropList py-2">
                            <li>
                                <div className="dropdown-item-text">
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="app-avatar app-avatar-lg"><FaUserCircle /></span>
                                        <div className="d-flex flex-column">
                                            <span className="fw-semibold">{adminName}</span>
                                            <span className="email">{profile?.email || "-"}</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li><hr className="dropdown-divider my-1 mb-2" /></li>
                            <li>
                                <button className="dropdown-item d-flex align-items-center gap-2" onClick={logOut} type="button">
                                    <FaSignOutAlt /> Logout
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
